const basePandoraUrl = "https://stage-try.becausemarket.com/checkout/logged";
console.log(basePandoraUrl)
const isCurrentUserActive = () => (window.userData && window.userData.accountState === 'active' && window.userData.portalToken);

window.trackMixpanelEvent = window.trackMixpanelEvent || function(eventName, data) {
  try {
    mixpanel.track(eventName, data);
  } catch (err) {
    debug(`Failed to track cart event "${eventName}"`);
  }
}

function createCartAndRedirect(cart, fallback) {
  trackMixpanelEvent('Add to next box Button clicked')
  jQuery("#spinnerModal").modal('show')
  const getPrice = (item) => {
    const tags = window.ProductTags[item.product_id] || []
    const factor = item.properties?.purchase_type === "onetime" && !tags.includes('NonSubscriptionItem') ? 1.1 : 1
    return Math.round(item.price * factor)
  }
  const cartProducts = cart.items.map(item => ({
    price: getPrice(item),
    variant: `${item.variant_id}`,
    purchase_type: item?.properties?.purchase_type ?? 'subscription',
    product_quantity: item.quantity
  }))
  fetch(`${basePandoraUrl}/graphql`, {
    method: 'POST',
    headers: {'content-type': 'application/json'},
    credentials: 'include',
    body: JSON.stringify({
      query: `mutation CreateCart($products: [JSONScalar!]) {
      createCart(products: $products){
        cartToken
      }
    }`,
      variables: {
        products: cartProducts
      }
    })
  })
    .then(res => res.json())
    .then(res => {
      const { data: { createCart }} = res;
      if (createCart && createCart.cartToken) {
        const params = new URLSearchParams()
        params.set('portalToken', window.userData.portalToken);
        params.set('cartToken', createCart.cartToken);
        params.set('instant', '1');
        window.location.replace(`${basePandoraUrl}?${params.toString()}`);
      } else {
        fallback()
      }
    })
    .catch(fallback)
}

function getUserData() {
  return new Promise(function(resolve, reject) {
    fetch(`${basePandoraUrl}/token`, {
      method: 'GET',
      credentials: 'include'
    })
    .then(res => res.json())
    .then(res => {
      if (res && res.accountState) {
        window.userData = res
        if (isCurrentUserActive()) {
          $('.checkout__button:not(.checkout__button--cancel)').val('Add to Next Box')
          trackMixpanelEvent('Add to next box Button shown')
        }
        if (typeof window.rerenderApp === 'function') {
          window.rerenderApp()
        }
      }
      resolve()
    })
    .catch(err => console.error(err))
  }) 
}

document.addEventListener('DOMContentLoaded', async function() {
  window.userData = null
  if (getCookie('bcsToken')) {
    await getUserData()
  }
})
